/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-4371fb57.mjs';
import '../_chunks/dep-31d34e52.mjs';
import '../_chunks/dep-67e8723b.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-e4f65bc4.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-1aa18f5f.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-07f3660d.mjs';
import '../_chunks/dep-0d3220b0.mjs';
import '../_chunks/dep-895678a0.mjs';
import '../_chunks/dep-b2bdc7b9.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../_chunks/dep-b390ff23.mjs';
import '../_chunks/dep-35a4fd8d.mjs';
import '../_chunks/dep-54378e60.mjs';
import '../_chunks/dep-25b8bf4b.mjs';
import '../_chunks/dep-c40264c0.mjs';
import '../_chunks/dep-9d499243.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-0927ceb7.mjs';
import '../_chunks/dep-f0bd05df.mjs';
import '../config-provider/type.mjs';

var useCLASSNAMES = function useCLASSNAMES() {
  var classPrefix = usePrefixClass();
  return computed(function () {
    var tree = "".concat(classPrefix.value, "-tree");
    return {
      icon: "".concat(classPrefix.value, "-icon"),
      folderIcon: "".concat(classPrefix.value, "-folder-icon"),
      actived: "".concat(classPrefix.value, "-is-active"),
      disabled: "".concat(classPrefix.value, "-is-disabled"),
      treeIconRight: "".concat(classPrefix.value, "-icon-arrow-right"),
      treeIconDown: "".concat(classPrefix.value, "-icon-arrow-down"),
      treeNodeToggle: "".concat(classPrefix.value, "-tree-toggle"),
      tree: tree,
      treeTransition: "".concat(tree, "--transition"),
      treeBlockNode: "".concat(tree, "--block-node"),
      treeEmpty: "".concat(tree, "__empty"),
      treeList: "".concat(tree, "__list"),
      treeNode: "".concat(tree, "__item"),
      treeNodeOpen: "".concat(tree, "__item--open"),
      treeHoverAble: "".concat(tree, "--hoverable"),
      treeCheckable: "".concat(tree, "--checkable"),
      treeLabel: "".concat(tree, "__label"),
      treeLabelStrictly: "".concat(tree, "__label--strictly"),
      treeIcon: "".concat(tree, "__icon"),
      treeIconDefault: "".concat(tree, "__icon--default"),
      treeSpace: "".concat(tree, "__space"),
      treeOperations: "".concat(tree, "__operations"),
      treeNodeVisible: "".concat(tree, "__item--visible"),
      treeNodeHidden: "".concat(tree, "__item--hidden"),
      treeNodeEnter: "".concat(tree, "__item--enter-active"),
      treeNodeLeave: "".concat(tree, "__item--leave-active"),
      treeNodeDraggable: "".concat(tree, "__item--draggable"),
      treeNodeDragging: "".concat(tree, "__item--dragging"),
      treeNodeDragTipTop: "".concat(tree, "__item--tip-top"),
      treeNodeDragTipBottom: "".concat(tree, "__item--tip-bottom"),
      treeNodeDragTipHighlight: "".concat(tree, "__item--tip-highlight"),
      line: "".concat(tree, "__line"),
      lineIsLeaf: "".concat(tree, "__line--leaf"),
      lineIsFirst: "".concat(tree, "__line--first")
    };
  });
};
var injectKey = Symbol("treeProvider");
var dragInjectKey = Symbol("onDrag");

export { dragInjectKey, injectKey, useCLASSNAMES };
//# sourceMappingURL=constants.mjs.map
